export default "__VITE_ASSET__BEw0vQgy__"